<template>
  <v-dialog v-model="dialog" width="480">
    <v-card v-if="item">
      <v-toolbar color="primary" dense dark class="elevation-0">
        <v-toolbar-title>Tem Barcode / QR Code Thiết bị</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-6 text-center" id="printable-barcode-card">
        <div class="barcode-card elevation-1 pa-4">
          <div class="text-subtitle-1 font-weight-bold text-uppercase primary--text">
            {{ item.name }}
          </div>
          <div class="text-caption text--secondary mb-3">
            Mã thiết bị: <strong>{{ item.code }}</strong>
          </div>

          <!-- QR Code Image -->
          <div class="d-flex justify-center my-3">
            <img
              :src="qrCodeUrl"
              alt="QR Code"
              style="width: 140px; height: 140px;"
            />
          </div>

          <div class="text-body-2 font-weight-medium">
            Vị trí: {{ locationName }}
          </div>
          <div class="text-caption text--secondary">
            Cơ sở vật chất trường học LMS
          </div>
        </div>
      </v-card-text>

      <v-divider />
      <v-card-actions class="pa-4">
        <v-btn outlined @click="dialog = false">Đóng</v-btn>
        <v-spacer />
        <v-btn color="primary" depressed @click="printBarcode">
          <v-icon left>mdi-printer</v-icon> In tem
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { get } from 'lodash'

export default {
  name: 'AssetBarcodeDialog',
  props: {
    state: Boolean,
    item: Object
  },
  data() {
    return {
      dialog: false
    }
  },
  computed: {
    locationName() {
      return get(this.item, 'location.name', '-')
    },
    qrCodeUrl() {
      const code = get(this.item, 'code', '')
      return `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${code}`
    }
  },
  watch: {
    state(val) {
      if (val) this.dialog = true
    }
  },
  methods: {
    get,
    printBarcode() {
      const printable = document.getElementById('printable-barcode-card')
      const code = get(this.item, 'code', '')
      const win = window.open('', '', 'width=600,height=600')
      win.document.write(`
        <html>
          <head>
            <title>In Tem Thiết Bị - ${code}</title>
            <style>
              body { font-family: Arial, sans-serif; text-align: center; padding: 20px; }
              .barcode-card { border: 2px dashed #1565c0; border-radius: 8px; padding: 20px; display: inline-block; }
            </style>
          </head>
          <body>
            ${printable.innerHTML}
          </body>
        </html>
      `)
      win.document.close()
      win.focus()
      setTimeout(() => {
        win.print()
        win.close()
      }, 500)
    }
  }
}
</script>

<style scoped>
.barcode-card {
  border: 2px dashed #1565c0;
  border-radius: 8px;
  background: #fafafa;
}
</style>
